<template>
  <template v-if="userStore.userInfo.email && !userStore.userInfo.isSSO && !appStore.isCN && !userStore.companyUser">
    <div class="form-section flex-row flex-align-center flex-justify-between" ref="refFormSection">
      <div class="flex-column flex-justify-between">
        <div class="form-title">
          <h5>{{ $t('Newsletter Subscription Preferences') }}</h5>
          <span class="form-desc">{{ $t('Subscribe to our newsletter about news, offers and tips.') }}</span>
        </div>
      </div>
      <div class="subscript-switch">
        <span class="switch-btn" @click="handleSwitchSubscript"></span>
        <el-switch class="switch" v-model="subscriptStatus" :loading="subscriptLoading" />
      </div>
    </div>
  </template>
</template>

<script setup>
import { appStore, userStore } from '@/stores'
import { isEdmBlackList, reSubEdm, unSubEdm } from '@/api/user/user'
import { getCurrentInstance, onMounted, ref } from 'vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import useFormImgVisible from '../hooks/useFormImgVisible'

const { $t } = getCurrentInstance().proxy

const subscriptStatus = ref(true)
const subscriptLoading = ref(false)
// 获取邮箱是否已订阅
const handleGetSubscriptStatus = async () => {
  if (!userStore.userInfo.email) return
  try {
    const { data } = await isEdmBlackList({
      email: userStore.userInfo.email,
    })
    subscriptStatus.value = !data
  } catch (e) {
    subscriptStatus.value = true
  }
}
// 切换订阅状态
const handleSwitchSubscript = async () => {
  if (subscriptLoading.value) return
  subscriptLoading.value = true
  try {
    if (subscriptStatus.value) {
      ElMessageBox.confirm(
        $t('After unsubscribing, you will no longer receive our email notifications, news, offers, and tips.'),
        $t('Confirm'),
        {
          center: true,
          confirmButtonText: $t('Ok'),
          cancelButtonText: $t('Cancel'),
          type: 'none',
          beforeClose: async (action, instance, done) => {
            if (action === 'confirm') {
              instance.confirmButtonLoading = true
              try {
                // 取消订阅
                await unSubEdm({
                  reason: 1,
                  unsubSource: 'Account center',
                  email: userStore.userInfo.email,
                })
                subscriptStatus.value = false
                ElMessage({
                  type: 'success',
                  message: $t('Canceled Successfully'),
                })
                done()
              } catch (err) {
                console.error(err);
              }
              instance.confirmButtonLoading = false
            } else {
              done()
            }
          },
        }
      )
    } else {
      // 订阅
      await reSubEdm({ email: userStore.userInfo.email })
      subscriptStatus.value = true
      ElMessage({
        type: 'success',
        message: $t('Subscribed Successfully'),
      })
    }
  } catch (e) {
    console.log(e)
  }
  subscriptLoading.value = false
}

const refFormSection = ref()
const refFormImg = ref()
useFormImgVisible(refFormSection, refFormImg)

onMounted(() => {
  handleGetSubscriptStatus()
})
</script>

<style lang="scss" scoped>
.subscript-switch {
  position: relative;
  .switch-btn {
    position: absolute;
    inset: 0;
    z-index: 1;
  }
}
@media screen and (max-width: 500px) {
  .form-section {
    flex-direction: column;
    align-items: start;
    gap: 12px;
  }
}
</style>